import { initSocialProofFromDOM } from 'utils/socialProofToast'
import { mountWelcomeCoupon } from './mountWelcomeCoupon'

document.addEventListener('DOMContentLoaded', () => {
  initSocialProofFromDOM()
  mountWelcomeCoupon()
})
